import React from 'react';

const Orders: React.StatelessComponent = props => (
  <div>
    <h1> ORDERS route works</h1>
  </div>
);

export default Orders;
